'use client'

import { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getRoot, $isParagraphNode, $isTextNode, $createParagraphNode } from 'lexical'
import { $isMentionNode } from './MentionNode'

export default function CharacterLineEnforcerPlugin() {
    const [editor] = useLexicalComposerContext()

    useEffect(() => {
        return editor.registerUpdateListener(({ dirtyElements, dirtyLeaves }) => {
            if (dirtyElements.size === 0 && dirtyLeaves.size === 0) return

            editor.update(() => {
                const root = $getRoot()
                const paragraphs = root.getChildren().filter($isParagraphNode)

                for (const paragraph of paragraphs) {
                    const children = paragraph.getChildren()
                    const hasCharacterMention = children.some(
                        c => $isMentionNode(c) && c.getMentionType() === 'character'
                    )
                    if (!hasCharacterMention) continue

                    const textNodes = children.filter(c => $isTextNode(c) && c.getTextContent().trim() !== '')
                    if (textNodes.length === 0) continue

                    const emptyTextNodes = children.filter(c => $isTextNode(c) && c.getTextContent().trim() === '')
                    emptyTextNodes.forEach(n => n.remove())

                    const nextParagraph = $createParagraphNode()
                    textNodes.forEach(textNode => {
                        textNode.remove()
                        nextParagraph.append(textNode)
                    })
                    paragraph.insertAfter(nextParagraph)

                    const firstText = nextParagraph.getFirstChild()
                    if (firstText) {
                        firstText.select(firstText.getTextContentSize(), firstText.getTextContentSize())
                    }
                }
            }, { tag: 'character-line-enforcer' })
        })
    }, [editor])

    return null
}
